import React from 'react';
import styles from '../AddProduct.module.css';

function ProductOptions({
    showOrderNow,
    setShowOrderNow,
    RelatedProduct,
    setRelatedProduct,
    Trending,
    setTrendingNow,
    HotDeal,
    setHotDeal,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    return (
        <div className={styles['AddProduct-card']}>
            <h2 className={styles['AddProduct-card-title']}>Product options</h2>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Show "Order now" button
                </label>
                <select
                    name="showOrderNow"
                    className={styles['AddProduct-category']}
                    value={showOrderNow}
                    onChange={handleFieldChange(
                        'showOrderNow',
                        setShowOrderNow,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Related products
                </label>
                <select
                    name="RelatedProduct"
                    className={styles['AddProduct-category']}
                    value={RelatedProduct}
                    onChange={handleFieldChange(
                        'RelatedProduct',
                        setRelatedProduct,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="Same">Same category</option>
                    <option value="All">All products</option>
                </select>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Trending now
                </label>
                <select
                    name="Trending"
                    className={styles['AddProduct-category']}
                    value={Trending}
                    onChange={handleFieldChange(
                        'Trending',
                        setTrendingNow,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>Hot deal</label>
                <select
                    name="HotDeal"
                    className={styles['AddProduct-category']}
                    value={HotDeal}
                    onChange={handleFieldChange(
                        'HotDeal',
                        setHotDeal,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
        </div>
    );
}

export default ProductOptions;
